import { render, staticRenderFns } from "./ModalSegmentacao.vue?vue&type=template&id=19f3fbe0&"
import script from "./ModalSegmentacao.vue?vue&type=script&lang=js&"
export * from "./ModalSegmentacao.vue?vue&type=script&lang=js&"
import style0 from "./ModalSegmentacao.vue?vue&type=style&index=0&id=19f3fbe0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports